import { render, staticRenderFns } from "./QuarterlySales.vue?vue&type=template&id=746a4fdb&scoped=true"
import script from "./QuarterlySales.vue?vue&type=script&lang=js"
export * from "./QuarterlySales.vue?vue&type=script&lang=js"
import style0 from "./QuarterlySales.vue?vue&type=style&index=0&id=746a4fdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a4fdb",
  null
  
)

export default component.exports